import { useEffect, useState } from "react";
import { API_URL } from "../../constants/app";
import axios from "axios";
import { Box } from "@chakra-ui/react";
export default function TermOfCondition() {

    const [data, setData] = useState("");

    let condition = `${API_URL}/upload/Term_Of_Condition_En.html`;

    useEffect(() => {
        axios.get(condition, {}).then((res) => {
            setData(res.data)
        });
    }, [condition])
    
	return (
        <Box px="7vw" py="2vh">
            <div dangerouslySetInnerHTML={{ __html: data }} />
        </Box>
	);
}
